import { useState } from "react";
import { Button, Label, Modal, ModalBody, ModalFooter, ModalHeader, TextInput } from "flowbite-react";
import { HiPencil } from "react-icons/hi";
import { toast } from "react-toastify";
import { updatePlaylist } from "../../services/radio";

const EditPlaylistModal = ({ playlist, onUpdated }: any) => {
  const [isOpen, setOpen] = useState(false);
  const [title, setTitle] = useState(playlist.title);
  const [isDefault, setIsDefault] = useState(playlist.is_default ?? false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!title.trim()) return;
    setIsSubmitting(true);
    try {
      await updatePlaylist(playlist.id, { title, is_default: isDefault });
      toast.success("Playlist updated successfully!");
      onUpdated?.();
      setOpen(false);
    } catch (e) {
      toast.error("Failed to update playlist");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Button color="primary" onClick={() => setOpen(true)}>
        <div className="flex items-center gap-x-2">
          <HiPencil className="text-lg" />
          Edit
        </div>
      </Button>
      <Modal onClose={() => setOpen(false)} show={isOpen}>
        <ModalHeader>Edit Playlist</ModalHeader>
        <ModalBody>
          <Label htmlFor="edit-playlist-title">Title</Label>
          <TextInput
            id="edit-playlist-title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Playlist title"
          />
          <div className="mt-4 flex items-center gap-2">
            <label className="relative inline-flex cursor-pointer items-center">
              <input
                type="checkbox"
                className="peer sr-only"
                checked={isDefault}
                onChange={(e) => setIsDefault(e.target.checked)}
              />
              <div className="peer h-6 w-11 rounded-full bg-gray-200 after:absolute after:left-[2px] after:top-[2px] after:size-5 after:rounded-full after:border after:border-gray-300 after:bg-white after:transition-all after:content-[''] peer-checked:bg-blue-600 peer-checked:after:translate-x-full peer-checked:after:border-white peer-focus:outline-hidden peer-focus:ring-4 peer-focus:ring-blue-300 dark:border-gray-600 dark:bg-gray-700 dark:peer-focus:ring-blue-800"></div>
              <span className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">
                Default playlist
              </span>
            </label>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={handleSubmit}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Saving..." : "Save"}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default EditPlaylistModal;
